import { render, staticRenderFns } from "./SelectFilter.vue?vue&type=template&id=1982c84f"
import script from "@/components/select-filter/SelectFilter.ts?vue&type=script&lang=ts&external"
export * from "@/components/select-filter/SelectFilter.ts?vue&type=script&lang=ts&external"
import style0 from "./select-filter.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports